import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function useWaitlistStats(refreshMs = 0) {
  const [stats, setStats] = useState({ total: 0, hosts: 0, renters: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    let timer = null;

    const tick = async () => {
      try {
        const { data } = await axios.get(`${API}/waitlist/stats`);
        if (!cancelled) setStats(data);
      } catch {
        /* silent */
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    tick();
    if (refreshMs > 0) timer = setInterval(tick, refreshMs);
    return () => {
      cancelled = true;
      if (timer) clearInterval(timer);
    };
  }, [refreshMs]);

  return { ...stats, loading };
}
